module.exports = __webpack_public_path__ + "img/shape_circle--blue.f8ddb91.png";